import React from 'react';
import NodeContent from './NodeContent';
import { NodeHoverState } from './Node';
import classNames from 'classnames';
var NodeGroup = function (_a) {
    var icon = _a.icon, label = _a.label, onClick = _a.onClick, hoverState = _a.hoverState, children = _a.children;
    return (React.createElement("div", { className: classNames('nodeGroup', { 'node--dimmed': hoverState === NodeHoverState.DIMMED }), onClick: onClick },
        React.createElement(NodeContent, { label: label, icon: icon }),
        children ?
            React.createElement("div", { className: 'nodeGroup__children' }, children)
            : null));
};
export default NodeGroup;
//# sourceMappingURL=NodeGroup.js.map